import React from 'react';
// import { FiFacebook, FiInstagram, FiLinkedin, FiTwitter } from 'react-icons/fi';

const PLATFORM_LINKS = ['Home', 'About', 'How It Works', 'Non Profit', 'People In Need', 'Contact'];
const SUPPORT_LINKS = ['Privacy Policy', 'Terms of Service', 'Contact Us', 'Help Center'];

/* function SocialBtn({ icon }) {
  return (
    <button
      className="flex items-center justify-center rounded-full cursor-pointer transition-all duration-200"
      style={{ width: '40px', height: '40px', border: '1px solid rgba(255,255,255,0.15)', color: '#3FC4E3', background: 'transparent' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(63,196,227,0.12)'; e.currentTarget.style.borderColor = 'rgba(63,196,227,0.4)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; }}
    >
      {icon}
    </button>
  );
} */

function FooterCol({ heading, links }) {
  return (
    <div>
      <div style={{ fontFamily: 'popinsSemiBold', fontSize: '13px', color: '#ffffff', marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {heading}
      </div>
      <ul className="flex flex-col gap-3">
        {links.map((link) => (
          <li key={link}>
            <a
              href="/"
              style={{ color: 'rgba(255,255,255,0.55)', fontFamily: 'popinsRegular', fontSize: '14px', textDecoration: 'none', transition: 'all 200ms ease', paddingLeft: '0px', display: 'block' }}
              onMouseEnter={(e) => { e.currentTarget.style.color = '#ffffff'; e.currentTarget.style.paddingLeft = '4px'; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.55)'; e.currentTarget.style.paddingLeft = '0px'; }}
            >
              {link}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer style={{ background: '#1B1A28' }}>
      {/* Top grid */}
      <div
        className="max-w-screen-xl mx-auto grid grid-cols-2 lg:grid-cols-3 footer-top"
        style={{ gap: '48px' }}
      >
        {/* Brand */}
        <div className="col-span-2 lg:col-span-1">
          <div style={{ marginBottom: '16px' }}>
            <img
              src="/logo.png"
              alt="Tarrant County Connect+"
              style={{ height: '44px', width: 'auto' }}
            />
          </div>
          <p style={{ fontFamily: 'popinsRegular', fontSize: '14px', color: 'rgba(255,255,255,0.5)', lineHeight: '1.8', marginBottom: '24px' }}>
            TCCplus is a non-profit platform connecting organizations with the communities they serve.
          </p>
          {/* <div className="flex gap-3">
            <SocialBtn icon={<FiFacebook size={16} />} />
            <SocialBtn icon={<FiInstagram size={16} />} />
            <SocialBtn icon={<FiLinkedin size={16} />} />
            <SocialBtn icon={<FiTwitter size={16} />} />
          </div> */}
        </div>

        <FooterCol heading="Platform" links={PLATFORM_LINKS} />
        <FooterCol heading="Support" links={SUPPORT_LINKS} />
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div
          className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3"
          style={{ padding: '24px 5%' }}
        >
          <span style={{ fontFamily: 'popinsRegular', fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>
            © 2026 TCCplus. All rights reserved.
          </span>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{
              background: 'rgba(63,196,227,0.1)', border: '1px solid rgba(63,196,227,0.25)',
              borderRadius: '8px', padding: '8px 16px', cursor: 'pointer',
              fontFamily: 'popinsMedium', fontSize: '13px', color: '#3FC4E3',
              display: 'flex', alignItems: 'center', gap: '6px',
              transition: 'all 200ms ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(63,196,227,0.2)'; e.currentTarget.style.borderColor = 'rgba(63,196,227,0.5)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(63,196,227,0.1)'; e.currentTarget.style.borderColor = 'rgba(63,196,227,0.25)'; }}
          >
            ↑ Back to top
          </button>
        </div>
      </div>
    </footer>
  );
}
